export const compensationTypes = [
  { key: 'cash', title: 'Cash' },
  { key: 'equity', title: 'Equity' },
  { key: 'profit-share', title: 'Profit Share' },
  { key: 'free', title: 'Free' },
].map(x => ({ ...x, id: x.key }))
